import styled from 'styled-components'
import IMAGES from '../../images'
import {
  NORMAL_FONT_SIZE_DESKTOP, NORMAL_FONT_SIZE_MOBILE, NORMAL_FONT_SIZE_TABLET,
  TITLE_FONT_SIZE_DESKTOP,
  TITLE_FONT_SIZE_MOBILE,
  TITLE_FONT_SIZE_TABLET,
} from '../../constant'

export const LandingFooterWrapper = styled.footer`
    padding: 56px 16px 24px 16px;
    background-image: url(${props => props.backgroundImage});
    background-position: center center;
    background-size: cover;
    @media only screen and (max-width: 768px) {
        padding: 24px 16px;
    }
    @media only screen and (max-width: 480px) {
        padding: 16px 16px 24px 16px;
    }
`
export const FooterLogo = styled.div`
  @media only screen and (max-width: 480px) {
    text-align: center;
    img {
      height: 32px;
    }
  }
`
export const CopyRight = styled.div`
  text-align: center;
  color: #EAEAEA;
  font-size: 14px;
  font-weight: 500;
  margin-top: 28px;
`
export const RewardRowWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 768px) {
    margin-top: 16px;
    border-top: 1px solid rgb(221 221 221);
    img {
      margin-right: 8px;
    }
  }
  @media only screen and (max-width: 480px) {
    border-top: none;
    flex-direction: column;
    img {
      margin-right: 0px;
    }
  }

  
`
export const RewardRow = styled.div`
  display: flex;
  gap: 24px;
  padding: 16px 8px;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`
export const RewardItem = styled.div`
  border-right: 1px solid rgb(221 221 221);
  padding-right: 24px;
  &:last-child {
    border-right: none;
    padding-right: 0;
  }
  @media only screen and (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid rgb(221 221 221);
    padding-bottom: 16px;
    padding-right: 0;
    &:last-child {
      border-bottom: none;
    }
  }
`
export const RewardTitle = styled.div`
  padding: 4px;  
  color: #ffffff;
  font-size: 13px;
  @media only screen and (max-width: 1600px) {
    font-size: 16px;
  }
  @media only screen and (max-width: 768px) {
  }
  @media only screen and (max-width: 480px) {
    padding: 8px;
  }
`
export const RewardDescription = styled.div`
  padding: 4px;  
  margin-top: 16px;
  color: rgb(223 223 223);
  font-size: 13px;
  @media only screen and (max-width: 768px) {
  }
  @media only screen and (max-width: 480px) {
    padding: 8px;
  }
`
export const ContactRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgb(221 221 221);
  border-bottom: 1px solid rgb(221 221 221);
  padding: 32px;
  flex-wrap: wrap;
  gap: 16px;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: start;
    padding: 16px 0;
  }
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    align-items: start;
    padding: 16px 0;
  }
`
export const ContactItem = styled.div`
  font-size: 13px;
  font-weight: 400;
  padding-left: 30px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 16px;
  a {
    color: #ffffff;
    text-decoration: none;
  }  
  @media only screen and (max-width: 768px) {
    padding: 0;
  }
  @media only screen and (max-width: 480px) {
    padding: 0 0 0 16px;
  }
`
export const DividerVertical = styled.div`
  width: 2px;
  height: 80px;
  background: hsla(0,0%,100%,.3);
  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 2px;
    margin: 16px 0;
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
    height: 2px;
    margin: 16px 0;
  }
`